import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Tag } from "@design-system/Tag/Tag";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { AccountingMigrationRow } from "../utils";

export const StatusCell = memo(function StatusCell({
    row,
}: CellContext<ViewTableFeatures, AccountingMigrationRow, unknown>) {
    const isComplete = row.original.status === "complete";

    return (
        <ViewTableCell>
            <Tag color={isComplete ? "accent" : "neutral"}>
                {isComplete ? "Complete" : "In progress"}
            </Tag>
        </ViewTableCell>
    );
});
